import { combineReducers } from 'redux';

import siteState from './site'

export default combineReducers({
    siteState
})